import { BaseResponse } from '@app/entities/BaseResponse';
import { apiRequest } from './apiUtils';

export interface NotificationResponse {
  id: number;
  title: string;
  message: string;
  isRead: boolean;
  readOnUtc: Date;
  readby: string;
  createdOnUtc: Date;
}


const BASE_URL = 'notification-center';

export const getLatestNotifications = (): Promise<NotificationResponse[] | null> =>
  apiRequest<BaseResponse<NotificationResponse[]>>(
    'GET',
    `${BASE_URL}/latest`
  ).then(res => res.data || null);

export const getNotificationsByPage = (
  pageNumber: number,
  pageSize: number
): Promise<BaseResponse<any>> =>
  apiRequest<BaseResponse<any>>(
    'GET',
    BASE_URL,
    {
      params: {
        pageSize,
        pageNumber
      }
    }
  );

export const markNotificationAsRead = (
  notificationId: number
): Promise<boolean> =>
  apiRequest<BaseResponse<boolean>>(
    'PUT',
    `${BASE_URL}/${notificationId}/mark-read`
  ).then(res => res.data);

export const deleteNotification = (
  notificationId: number
): Promise<boolean> =>
  apiRequest<BaseResponse<boolean>>(
    'DELETE',
    `${BASE_URL}/${notificationId}`
  ).then(res => res.data);
